// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title_ap5vG, .accessories_ruTxz {
  display: flex;
  flex-direction: row;
}

.title_ap5vG {
  margin-right: auto !important;
}

.accessories_ruTxz {
  margin-left: auto !important;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/main/actions/ToolbarFactory.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".title, .accessories {\n  display: flex;\n  flex-direction: row;\n}\n\n.title {\n  margin-right: auto !important;\n}\n\n.accessories {\n  margin-left: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `title_ap5vG`,
	"accessories": `accessories_ruTxz`
};
export default ___CSS_LOADER_EXPORT___;
